import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import config from 'config/api';
import { getToken } from 'components/UI/Account/ducks/authentication';
import Typography from '@material-ui/core/Typography';
import i18n from 'helpers/i18n';
import Template from 'components/UI/Template/Template';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import DocumentationList from 'components/UI/Documentation/DocumentationList';


const useStyles = makeStyles((theme) => ({
  root: {
    //flexGrow: 1,
    minHeight: '100%',
    width: '100%',
  },
  pageTitle: {
    paddingTop: 70,
    color:'#fff',
    fontSize:'3rem',
    fontWeight:'bold',
  },

  paperWrapper: {
    width: '100%',
    display: 'block',
    position: 'relative',
    '&:before': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      content: "' '",
      height: '230px',
      background: 'url('+require('assets/images/header_documentation.jpg')+')',
      backgroundSize: 'cover',
      backgroundColor: theme.palette.primary.light,
      zIndex: -1
    }
  },
  paper: {
    marginTop:85,
    backgroundColor: 'transparent',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    //maxWidth: 1280,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.spacing(4),
    '& a': {
      color: 'inherit'
    }
  },

  tabs:{
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
      height: 3,
    },
  },
  tab:{
    marginRight: '50px',
    whiteSpace:'nowrap',
    maxWidth:'unset',
  }

}));


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


function tabTitle(title, count)
{
  if(count===undefined || count==0)
    count="0";
  return(
    <Typography variant="h3" style={{marginRight:'40px',marginBottom:'5px',color:'#222'}}><StyledBadge badgeContent={count} color="primary">{title}</StyledBadge></Typography>
  );
}

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -30,
    top: '50%',
    width: 30,
    height: 30,
    fontSize: '1rem',
    borderRadius: '180px'
  },
}))(Badge);


export default function DocumentationTabs(props) {

  const { classes } = props;
  
  const localClasses = useStyles();
  let history = useHistory();

  const [categories, setCategories]=React.useState({});

  useEffect(()=>{

    const fetchData = async () => {
      const url = config.documentation + '/list';
      var formData = new FormData();
      const token = await getToken();
      formData.append('csrf', token);
      return fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: {
          Accept: 'application/json, application/xml, text/plain, text/html, *.*',
          'X-Requested-With': 'XMLHttpRequest', // needed by php api
        },
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          //console.log("RESPONSE", response);
          if (response.status === 'ok' && response.data!==undefined) {
            setData(response.data);
          } else {
          }
        });
    };
  
    fetchData();
  }, []);

  const activePanel=getTabFromHash();

  function setData(data)
  {
    let categories={};
    if(data.fields!==undefined){
      data.fields.forEach((field)=>{
        if(field.id!='documentationCategory')
          return;
        field.options.forEach((opt)=>{
          categories[opt.value]={
              label:opt.label,
              count:0,
              rows:[],
            };
        });
      });
    }
    if(data.rows!==undefined){
      data.rows.forEach((row)=>{
        if(categories[row.documentationCategory]===undefined)
          return;
          categories[row.documentationCategory].count++;
          categories[row.documentationCategory].rows.push(row);
        });
    }
    //console.log(categories)
    setCategories(categories);
  }

  function getTabFromHash() {
    if(window.location.hash===undefined)
      return 0;
    const hash=window.location.hash.substring(1);
    const keys=Object.keys(categories);
    const index=keys.indexOf(hash);
    if(index!==-1)
      return index;
    return 0;
  }

  const handleChange = (_event, newValue) => {
    const keys=Object.keys(categories);
    if(newValue in keys)
      window.location.hash = '#'+keys[newValue];
  }

    return (
    <Template current="documentation">
      <Box className={localClasses.paperWrapper}>
        <Typography variant="h1" className={localClasses.pageTitle}>
          {i18n.get('documentationTitle')}
        </Typography>{' '}
        <Paper square elevation={0} className={localClasses.paper}>

        <AppBar square elevation={0} color="transparent" position="static">
          <Tabs value={activePanel} onChange={handleChange} className={localClasses.tabs}>
            {Object.keys(categories).map((categ, i)=>
              <Tab key={categ} className={localClasses.tab} label={tabTitle(categories[categ].label, categories[categ].count)} {...a11yProps(i)} />
            )}
          </Tabs>
        </AppBar>
        {Object.keys(categories).map((categ, i)=>
            <TabPanel key={categ} value={activePanel} index={i} className={localClasses.tabPanel}>
              <DocumentationList rows={categories[categ].rows}/>
          </TabPanel>
        )}
        </Paper>
        </Box>
      </Template>
    );
};



// WEBPACK FOOTER //
// ./src/components/UI/Documentation/DocumentationTabs.jsx